import React from 'react';

import {WifiSettingContextProvider} from '@/contexts/WifiSettingContext';

import WifiConfigContainer from './WifiConfigContainer';
import WifiList from './WifiList';

function AvailableWifiList() {
  return (
    <WifiSettingContextProvider>
      <div className="div-2col50">
        <WifiList />
        <WifiConfigContainer />
      </div>
    </WifiSettingContextProvider>
  );
}
export default React.memo(AvailableWifiList);
